module.exports = __webpack_public_path__ + "img/copyright.b207d90d.svg";